// Anonymous, privacy-safe content view tracking.
// No IP, user agent or personal data — just a random session id stored in the
// visitor's own browser. Fire-and-forget: never blocks rendering, never throws.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = 'eco-analytics-sid';

export const getAnalyticsSessionId = () => {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid || !/^[A-Za-z0-9-]{8,64}$/.test(sid)) {
    const uuid = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    sid = uuid.replace(/[^A-Za-z0-9-]/g, '');
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

export const trackView = (kind, slug) => {
  try {
    if (!kind || !slug) return;
    const day = new Date().toISOString().slice(0, 10);
    const dedupeKey = `eco-view:${day}:${kind}:${slug}`;
    if (sessionStorage.getItem(dedupeKey)) return;
    sessionStorage.setItem(dedupeKey, '1');
    fetch(`${API}/analytics/view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, slug, sid: getAnalyticsSessionId() }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // analytics must never break the page
  }
};
